<template>
  <div class="zoneFinalContainer">
    <b-modal
      :active="showLegionellaModal"
      scroll="keep"
      @close="showLegionellaModal = false"
    >
      <div class="card">
        <div class="card-content">
          <div class="field">
            <label>{{ $t("settings.antiLegionella") }} </label>

            <div class="select" style="width: 100%">
              <select style="width: 100%" v-model.number="legionellaConf">
                <option value="0">0</option>
                <option value="7">7</option>
                <option value="14">14</option>
                <option value="30">30</option>
              </select>
            </div>

            <div
              class="media"
              style="
                margin-top: 15px;
                display: flex;
                flex-direction: row-reverse;
              "
            >
              <a class="button is-success" @click="saveLegionellaConfig">
                {{ $t("buttons.save") }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <h2 class="zoneName">
      <span class="icon clickable returnIcon" @click="goParent()">
        <i class="mdi mdi-chevron-left"></i>
      </span>
      {{ zone.name }}
    </h2>

    <div class="hiloPilot" v-if="zone.pilot_mode">
      {{ $t("zone.hasPilot") }}
    </div>

    <div
      class="deviceOptions columns is-centered is-variable is-mobile is-5"
      style="margin-bottom: -25px"
    >
      <div>
        <div class="column is-1">
          <span v-if="zone.type === constants.zoneTypes.acs">
            <img
              src="/home/images/thermostat/icn_covid.png"
              @click="showLegionellaModal = true"
            />
          </span>
          <span v-else>
            <img
              v-if="zone.windows_open_mode"
              @click="setWindowMode({ zone, value: false })"
              src="/home/images/thermostat/icn_ventanas_abiertas.png"
            />
            <img
              v-else
              @click="setWindowMode({ zone, value: true })"
              src="/home/images/thermostat/icn_ventanas_abiertas_off.png"
            />
          </span>
        </div>

        <div class="column is-1">
          <span>
            <img
              v-if="zone.block_remote"
              @click="setLockMode({ zone, value: false })"
              src="/home/images/thermostat/modo_bloqueo_remoto_on.png"
            />
            <img
              v-else-if="zone.block_local"
              @click="setLockRemoteMode({ zone, value: true })"
              src="/home/images/thermostat/modo_bloqueo_remoto_teclado_on.png"
            />
            <img
              v-else
              @click="setLockMode({ zone, value: true })"
              src="/home/images/thermostat/modo_bloqueo_remoto_teclado_off.png"
            />
          </span>
        </div>

        <div
          class="column is-1"
          @click="
            $router.push(
              '/installations/' +
                installation['.key'] +
                '/zone/' +
                zone.path.split('/')[zone.path.split('/').length - 1] +
                '/program'
            )
          "
        >
          <span>
            <img src="/home/images/control/icn_calendar.png" />
          </span>
        </div>
        <div class="column is-1" @click="goToStatistics()">
          <span>
            <img src="/home/images/control/icn_graficas.png" />
          </span>
        </div>
      </div>
    </div>

    <knob-control
      v-if="temperature"
      :min="range.min"
      :max="range.max"
      :data="zone"
      :auto="auto"
      type="zone"
      v-on:toggle-mode="updateMode"
      v-on:update-temp="updateTemp"
      v-model="temperature"
      :disabled="disabled"
      :isFloor="isFloor"
      :autoMode="autoMode"
      :autoTemp="autoTemp"
      :iceMode="zone.ice_mode"
      :power="zone.power"
      :inconsistent="inconsistent"
    ></knob-control>

    <div class="zoneOptions columns is-centered is-variable is-mobile is-5">
      <div>
        <div
          class="column is-1"
          @click="togglePower"
          v-bind:class="{ active: zone.power }"
        >
          <img
            v-if="
              zone.power &&
              !(
                zone.power &&
                zone.mode === 'auto' &&
                autoMode === 'O' &&
                !zone.ice_mode
              )
            "
            src="/home/images/thermostat/btn_encender_off.png"
          />
          <img v-else src="/home/images/thermostat/btn_encender_on.png" />
        </div>

        <div
          v-if="!isFloor"
          class="column is-1"
          @click="setStatus('ice')"
          v-bind:class="{ active: this.isActiveClass('ice') }"
        >
          <img
            v-if="isActiveClass('ice')"
            src="/home/images/thermostat/btn_antihielo_on.png"
            class="clickable optionTitle"
          />
          <img
            v-else
            src="/home/images/thermostat/btn_antihielo_off.png"
            class="clickable optionTitle"
          />
        </div>
        <div
          v-if="!isFloor"
          class="column is-1"
          @click="setStatus('eco')"
          v-bind:class="{ active: this.isActiveClass('eco') }"
        >
          <img
            v-if="isActiveClass('eco')"
            src="/home/images/thermostat/btn_eco_on.png"
            class="clickable optionTitle"
          />
          <img
            v-else
            src="/home/images/thermostat/btn_eco_off.png"
            class="clickable optionTitle"
          />
        </div>
        <div
          v-if="!isFloor"
          class="column is-1"
          @click="setStatus('comfort')"
          v-bind:class="{ active: this.isActiveClass('comfort') }"
        >
          <img
            v-if="isActiveClass('comfort')"
            src="/home/images/thermostat/btn_confort_on.png"
            class="clickable optionTitle"
          />
          <img
            v-else
            src="/home/images/thermostat/btn_confort_off.png"
            class="clickable optionTitle"
          />
        </div>
      </div>
    </div>
    <p class="modeName">{{ getModeName() }}</p>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import constants from "@/config/constants";
import KnobControl from "@/components/shared/KnobControl.vue";
import colors from "@/mixins/colors";
import { EventBus } from "@/util/event-bus";
import * as timezones from "@/util/timezones.json";
import moment from "moment-timezone";

export default {
  components: {
    KnobControl,
  },
  mixins: [colors],
  name: "zone-final-thermostat",
  data() {
    return {
      showLegionellaModal: false,
      legionellaConf: null,
      temperature: null,
      auto: null,
      warmUpTimer: null,
      inconsistent: false,
      constants,
    };
  },
  computed: {
    ...mapState("installations", {
      installation: "current",
      tariff: "currentTariff",
    }),

    ...mapState("zones", {
      devices: "devices",
      zone: "current",
    }),

    autoMode() {
      let tz = timezones.default.find(
        (tz) => tz.value === this.installation.timeZoneId
      );

      if (!tz) {
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        timezones.default.every((ti) => {
          let myUtc = ti.utc.find((utc) => utc === timezone);
          if (myUtc) {
            tz = ti;
            return false;
          }
          return true;
        });
      }

      if (this.zone.schedule === undefined)
        this.zone.schedule = constants.defaultProgram;

      let date = moment.utc().tz(tz.utc[0]);
      let currentDay = date.day() > 0 ? date.day() - 1 : 6;
      let currentHour = date.hour();
      return this.zone.schedule[currentDay].charAt(currentHour);
    },

    autoTemp() {
      switch (this.autoMode) {
        case "O":
          return this.zone.type === "acs"
            ? constants.acsIceModeTemp
            : constants.iceModeTemp;
        case "C":
          return this.zone.comfort;
        case "E":
          return this.zone.eco;
      }
    },

    range: function () {
      if (!this.zone.type) this.zone.type = "unknown";

      return {
        min: constants.ranges.thermostat[this.zone.type].min,
        max: constants.ranges.thermostat[this.zone.type].max,
      };
    },

    disabled: function () {
      return this.zone.pilot_mode;
    },

    isFloor: function () {
      return this.zone.type === constants.zoneTypes.floor;
    },
  },
  watch: {
    zone: function () {
      this.loadState();
    },
  },
  methods: {
    ...mapActions("zones", {
      setZoneStatus: "setStatus",
      setZoneMode: "setMode",
      setWindowMode: "setWindowMode",
      setZonePower: "setPower",
      setLockMode: "setLockMode",
      setLockRemoteMode: "setLockRemoteMode",
      setLegionellaConfig: "setLegionellaConfig",
      setZoneTemperature: "setTemperature",
      updateWarmUp: "updateFloorDevices",
    }),

    saveLegionellaConfig() {
      this.setLegionellaConfig({
        zone: this.zone,
        config: this.legionellaConf,
      });
      this.showLegionellaModal = false;
    },

    goToStatistics: function () {
      let hasTariff = this.tariff.filter((hour) => hour > 0).length > 0;
      if (!hasTariff) {
        this.$dialog.alert(this.$t("statistics.noTariff"));
        return false;
      }

      if (!this.installation.zones) {
        this.$dialog.alert(this.$t("statistics.noDevices"));
        return false;
      }

      let devices = [];

      function getDevices(zone) {
        if (
          zone.zones === undefined &&
          zone.final &&
          zone.devices !== undefined
        ) {
          //ADD DEVICES
          Object.keys(zone.devices).forEach((device) => {
            devices.push(device);
          });
        }
        if (zone.zones !== undefined)
          Object.values(zone.zones).forEach((z) => getDevices(z));
      }

      getDevices(this.zone);

      if (devices.length === 0) {
        this.$dialog.alert(this.$t("statistics.noDevices"));
        return false;
      }

      this.$router.push(
        "/installations/" +
          this.installation[".key"] +
          "/zone/" +
          this.zone.path.split("/")[this.zone.path.split("/").length - 1] +
          "/statistics"
      );
    },

    getModeName() {
      if (!this.zone.power) return "";

      switch (this.zone.status) {
        case "eco":
          return this.$t("thermostat.eco");

        case "ice":
          return this.$t("thermostat.ice");

        case "comfort":
          return this.$t("thermostat.comfort");
      }
    },

    loadState: function () {
      this.inconsistent = this.getZoneFinalInconsistency(this.zone) === "";
      this.temperature = this.zone.temp;
      this.legionellaConf = this.zone.legionella_conf;
      this.auto = this.zone.mode === "auto";
    },

    setStatus: function (status) {
      if (!this.disabled) {
        this.setZoneStatus({ zone: this.zone, status: status });
        this.setPower(true);
      } else {
        this.$toast.error(this.$t("zone.hasPilot"), {
          duration: 4000,
        });
      }
    },
    togglePower: function () {
      let power = !this.zone.power;
      this.setZonePower({ zone: this.zone, power: power });
    },

    isActiveClass: function (val) {
      let zone = this.zone;
      if (!zone.power) return false;

      switch (val) {
        case "eco":
          return (
            (zone.status === "eco" && zone.power && zone.mode === "manual") ||
            (zone.mode === "auto" && this.autoMode === "E")
          );
        case "comfort":
          return (
            (zone.status === "comfort" &&
              zone.power &&
              zone.mode === "manual") ||
            (zone.mode === "auto" && this.autoMode === "C")
          );
        case "ice":
          return (
            (zone.status === "ice" && zone.power && zone.mode === "manual") ||
            (zone.mode === "auto" && this.autoMode === "O" && zone.ice_mode)
          );
      }
    },
    setMode: function () {
      let mode = this.auto ? "auto" : "manual";
      this.setPower(true);
      this.setZoneMode({ zone: this.zone, mode: mode });
    },

    setPower: function (power) {
      this.setZonePower({ zone: this.zone, power: power });
    },

    setTemperature: function (temp) {
      if (temp === "-") return false;
      this.setPower(true);
      this.temperature = temp;
      this.setZoneTemperature({ zone: this.zone, temperature: temp });
    },

    goParent: function () {
      let zoneArray = this.zone.path
        .split("/zones/")
        .filter(
          (idZone) =>
            idZone.length > 0 &&
            idZone !==
              this.zone.path.split("/")[this.zone.path.split("/").length - 1]
        );
      let path = "/installations/" + this.installation[".key"];
      if (zoneArray.length > 0)
        path += "/zone/" + zoneArray[zoneArray.length - 1];
      this.$router.push(path);
    },
    updateMode: function (auto) {
      this.auto = auto;
      this.setMode();
    },
    updateTemp: function (temp) {
      this.setTemperature(temp);
    },
  },
  mounted() {
    this.loadState();

    EventBus.$on("deviceUpdate", () => {
      this.inconsistent = this.getZoneFinalInconsistency(this.zone) === "";
    });

    if (this.zone.type === constants.zoneTypes.floor) {
      this.updateWarmUp();
      this.warmUpTimer = setInterval(() => {
        this.updateWarmUp();
      }, constants.refreshInterval);
    }
  },

  beforeDestroy() {
    clearInterval(this.warmUpTimer);
  },
};
</script>

<style lang="scss" scoped>
.zoneFinalContainer {
  color: white;
  height: 100%;
}

.column {
  width: 5rem !important;
  display: flex;
  align-items: center;

  img {
    padding: 0 !important;
    cursor: pointer;
  }
}

.optionTitle {
  padding-bottom: 0.5rem;
}

.optionText {
  display: none;
}

.active > .optionText {
  display: block;
}

.zoneName {
  padding-top: 5rem;
  padding-bottom: 1.5rem;
  font-size: 2.5rem;
  font-weight: bold;
}

.zoneOptions {
  padding: 2rem;
  display: flex;

  > div:first-child {
    display: flex;
    border: 1px solid white;
    border-radius: 50px;
    padding: 0 10px;
  }
}

.modeName {
  margin-top: -30px;
}

.hiloPilot {
  font-size: large;
}

.zoneFinalContainer .columns.is-centered.is-variable {
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
}

@media screen and (max-width: 1087px) {
  .zoneName {
    padding-top: 4rem;
  }
}
</style>
